import axios from 'axios';
import * as CryptoJS from 'crypto-js';

const baseURL = `${process.env.REACT_APP_API_URL}/accounts/index.php`;
let CryptoJSAesJson = {
    /**
     * Encrypt any value
     * @param {*} value
     * @param {string} password
     * @return {string}
     */
    'encrypt': function (value, password) {
        return CryptoJS.AES.encrypt(JSON.stringify(value), password, { format: CryptoJSAesJson }).toString()
    },
    /**
     * Decrypt a previously encrypted value
     * @param {string} jsonStr
     * @param {string} password
     * @return {*}
     */
    'decrypt': function (jsonStr, password) {
        return JSON.parse(CryptoJS.AES.decrypt(jsonStr, password, { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8))
    },
    /**
     * Stringify cryptojs data
     * @param {Object} cipherParams
     * @return {string}
     */
    'stringify': function (cipherParams) {
        var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) }
        if (cipherParams.iv) j.iv = cipherParams.iv.toString()
        if (cipherParams.salt) j.s = cipherParams.salt.toString()
        return JSON.stringify(j).replace(/\s/g, '')
    },
    /**
     * Parse cryptojs data
     * @param {string} jsonStr
     * @return {*}
     */
    'parse': function (jsonStr) {
        var j = JSON.parse(jsonStr)
        var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
        if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
        if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
        return cipherParams
    }
}

export const accountService = {
    signIn,
    getGoogleUserInfo,
    mobileSignIn,
    getRegistrationByPaymentID
};

async function signIn(loginData) {
    // console.log(loginData);
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(loginData, password);

    return await axios.post(`${baseURL}?type=4`, encrypted)
        .then(response => response.data)
        .catch(err => console.log(err));
}

async function getGoogleUserInfo(tokenResponse) {
    try {
        return await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
            headers : {
                "Authorization": `Bearer ${tokenResponse.access_token}` 
            }
        });
    } catch (err) {
        console.log(err);
        return err;
    }

}

async function mobileSignIn(individualID, tempID){
    let valueToEncrypt = {
        individualID : individualID,
        tempID : tempID
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // console.log(encrypted);

    // check the existence of the runner
    return await axios.post(`${baseURL}?type=13`, encrypted)
                .then(response => response.data)
                .catch(err => {console.log(err.response)});
}

async function getRegistrationByPaymentID(paymentID, token) {
    let valueToEncrypt = {
        paymentID : paymentID,
        token : token
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // console.log(encrypted);

    // check the existence of the runner
    return await axios.post(`${baseURL}?type=24`, encrypted)
                .then(response => response.data)
                .catch(err => {console.log(err.response)});
}